@if (!isMobile) {
<div class="custom-input-wrapper">
  <input type="text" [attr.placeholder]="placeholder" class="custom-input" [(ngModel)]="selectItem.label"
    [readonly]="preventDeleteKeys"
    [ngClass]="{'with-suggestion': isInputActive }" (input)="filtro($event)" (focus)="showSuggestions(true)"
    (keydown)="onInputKeydown($event)">
  <div class="suggestions" #suggestions>
    <ul class="autocomplete-list">
      @for (item of listFiltroItems; track item) {
      <li (mousedown)="setValue(item)" (touchstart)="setValue(item)">
        {{ item?.label }}
      </li>
      }
    </ul>
  </div>
</div>
}
@if (isMobile && !mobileTapList) {
<div class="mobile-select-wrapper">
  <select class="input mobile-select" [value]="selectItem?.value || ''" (change)="onSelectChange($event)">
    <option value="" disabled>{{ placeholder }}</option>
    @for (item of listItems; track item) {
    <option [value]="item.value" [selected]="selectItem?.value === item.value">
      {{ item.label }}
    </option>
    }
  </select>
</div>
}
@if (isMobile && mobileTapList) {
<div class="mobile-select-wrapper">
  <button type="button" class="input mobile-select mobile-select--tap"
    [ngClass]="{'with-suggestion': isInputActive}" (click)="toggleMobileList()">
    {{ selectItem?.label || placeholder }}
  </button>
  <div class="suggestions" #suggestions>
    <ul class="autocomplete-list">
      @for (item of listItems; track item) {
      <li (click)="setValue(item)">
        {{ item?.label }}
      </li>
      }
    </ul>
  </div>
</div>
}